const translations: { [key: string]: { [key: string]: string } } = {
  accountverification: {
    APP_TITLE: 'Auto Verification Tool',
    IDENTITY_TITLE: 'Verify your identity',
    DOCUMENT_TITLE: 'Verify your address',
    PAYMENT_TITLE: 'Verify your payment',
    APP_DESCRIPTION_LINE_1: 'We are required to have your account fully comply with the regulator requirements',
    APP_DESCRIPTION_LINE_2_BOLD: 'for Age and Verification',
    APP_DESCRIPTION_LINE_2: ', and for this, we will need the following documentation from you.',
    DOCUMENT_UPLOAD_MESSAGE: 'Please upload at least one of the following documents:',
    SCENARIO_NUMBER_TITLE: 'Step',
    CHAT_LINK_TITLE_LINE_1: 'If you need assistance',
    CHAT_LINK_TITLE_LINE_2: 'Contact us via chat',
    VERIFICATION_REQUIRED_BTN_VALUE: 'Start now',
    DOCUMENT_STATUS_VERIFIED: 'VERIFIED',
    DOCUMENT_STATUS_REJECTED: 'REJECTED',
    DOCUMENT_STATUS_PENDING: 'NOT UPLOADED',
    DOCUMENT_STATUS_REQUIRED: 'REQUIRED',
    DOCUMENT_STATUS_SUBMITTED: 'SUBMITTED',
    DOCUMENT_STATUS_NOT_UPLOADED: 'NOT UPLOADED',
    JOURNEY_COMPLETED_TITLE: 'Nice one!',
    VERIFICATION_ERROR_TITLE: 'You’re almost there',
    VERIFICATION_ERROR_MESSAGE_1: 'Hi ',
    VERIFICATION_ERROR_MESSAGE_2:
      'We were unable to verify your account via our Auto Verification tool so, your documents are currently being reviewed by our dedicated team.',
    VERIFICATION_ERROR_MESSAGE_3:
      'This can take up to 24 hours and we will email you to confirm if your account verification was successful.',
    VERIFICATION_ERROR_MESSAGE_4: 'Check out our',
    VERIFICATION_ERROR_LINK_MESSAGE: 'FAQ for Verification here.',
    VERIFICATION_COMPLETED: 'Your verification process has been completed. Your account is active.',
    VERIFICATION_COMPLETED_BUTTON_LABEL: 'Please login and enjoy.',
    VERIFICATION_COMPLETED_BUTTON_VALUE: 'Login',
    SUBMIT_CONFIRMATION:
      "Thank you - We have everything we need for now, and it shouldn't take us too long to review these and confirm back to you.",
    SUBMIT_CONFIRMATION_TERM: 'Usually confirmation takes up to 24h',
    SUBMIT_CONFIRMATION_FINISHED: 'We will let you know if there are any issues',
    SELECT_DOCUMENT_TYPE_TITLE: 'Select document type',
    SELECT_DOCUMENT_BACK_BTN: 'Back',
    PASSPORT: 'Passport',
    DRIVING_LICENSE: 'Driving Licence',
    IDENTIFY_CARD: 'Identity Card',
    BIRTH_CERTIFICATE: 'Birth certificate',
    BANK_STATEMENT: 'Bank statement',
    CASH_ADVANCE_APPLICATION: 'Cash advance application',
    COUNCIL_BILL: 'Council bill',
    CREDIT_CARD: 'Credit card',
    IMAGE_SHOWING_ACCOUNT: 'Screenshot of payment method',
    CREDIT_CARD_STATEMENT: 'Credit card statement',
    CORPORATE_RESOLUTION_CERTIFICATE: 'Corporate resolution certificate',
    HEALTH_CARE_CARD: 'Health care card',
    INSURANCE_CARD: 'Insurance card',
    LEASE_AGREEMENT: 'Lease agreement',
    LOAN_APPLICATION: 'Loan application',
    MEDICARE_CARD: 'Medicare card',
    MORTGAGE_APPLICATION: 'Mortgage application',
    PHONE_BILL: 'Phone bill',
    SCHOOL_ENROLMENT_LETTER: 'School enrolment letter',
    SENIORS_CARD: 'Seniors card',
    SUPERANNUATION_STATEMENT: 'Superannuation statement',
    SOCIAL_SECURITY_CARD: 'Social security card',
    STUDENT_CARD: 'Student card',
    TRADE_ASSOCIATION_CARD: 'Trade association card',
    TAX_RETURN: 'Tax return',
    UTILITY_BILL: 'Utility bill',
    VOIDED_CHECK: 'Voided check',
    VEHICLE_TITLE: 'Vehicle title',
    WORKING_WITH_CHILDREN_CHECK: 'Working with children check',
    ERROR_TITLE: 'Something went wrong…',
    ERROR_TITLE_TOKEN_EXPIRED: 'This link has expired',
    ERROR_MESSAGE: 'We are terribly sorry. Please try again.',
    ERROR_MESSAGE_TOKEN_EXPIRED:
      'We have sent you an email from verification@willhill.com. Please follow the instructions in it to complete your verification',
    ERROR_BUTTON_VALUE: 'Retry',
  },
};

export default translations;
